import OfferService from '@infrastructure/offer.api'

// solarproduct answers 503 with this detail when the final offer needs the Tarifa Justa minimum
// annual consumption written to Clips and Clips does not take it (card 215568).
export const MINIMUM_CONSUMPTION_NOT_WRITTEN =
  'Minimum annual consumption could not be written to Clips'

export function handleGetOffer({ respondWithOffer, respondWithError }) {
  return { execute }

  async function execute(payload) {
    if (!payload.cups) {
      return
    }

    try {
      const offer = await OfferService.getOffer(payload)
      if (offer.installation.isEligible) {
        respondWithOffer(offer)
      } else {
        respondWithError('offer-error')
      }
    } catch (error) {
      respondWithError(
        isMinimumConsumptionNotWritten(error)
          ? 'minimum-consumption-error'
          : 'api-error'
      )
    }
  }
}

function isMinimumConsumptionNotWritten(error) {
  return (
    error?.response?.status === 503 &&
    error?.response?.data?.detail === MINIMUM_CONSUMPTION_NOT_WRITTEN
  )
}
